import { Box, Text } from "@mantine/core";
import { IconBan } from "@tabler/icons-react";
import UserAvatar from "components/UserAvatar";
import { useTranslation } from "react-i18next";

type IncomingMessageProps = {
  message?: string | null;
  time?: string | null;
  senderName?: string | null;
  senderAvatar?: string | null;
  attachments?: React.ReactNode;
  isEdited?: boolean;
  isDeleted?: boolean;
};

const IncomingMessage = ({
  message,
  time,
  senderName,
  senderAvatar,
  attachments,
  isEdited,
  isDeleted,
}: IncomingMessageProps) => {
  const { t } = useTranslation("messages");
  return (
    <Box className="flex justify-start">
      <Box mt={8} ml={"10px"} mr={"6px"}>
        <UserAvatar
          userName={senderName ?? ""}
          avatarId={senderAvatar ?? ""}
          size={20}
        />
      </Box>
      <Box className="px-[7px] my-2 rounded-lg max-w-[85%] min-w-[20%] rounded-tl-none rounded-tr-[7px] rounded-bl-[7px] rounded-br-[7px] wrap-break-word whitespace-pre-wrap bg-white">
        <Box className="flex flex-col gap-0">
          <Text fz="14px" c={"var(--color-gray-dark)"} fw={600}>
            {senderName}
          </Text>
          {!isDeleted && attachments}
          {isDeleted ? (
            <Box
              className="flex items-center gap-1"
              style={{ marginTop: "-6px" }}
            >
              <IconBan size={20} color="var(--color-gray-medium)" />
              <Text fz="md" c="var(--color-gray-medium)">
                {t("messageDeleted")}
              </Text>
            </Box>
          ) : (
            <Text
              fz="md"
              c="var(--color-gray-dark)"
              style={{ marginTop: "-6px" }}
            >
              {message}
            </Text>
          )}
        </Box>
        {time ? (
          <Box className="flex items-center justify-end gap-1 h-2.5 pb-1">
            {isEdited && !isDeleted && (
              <Text fz={12} c={"var(--color-gray)"}>
                {t("edited")}
              </Text>
            )}
            <Text fz={12} c={"var(--color-gray)"}>
              {time}
            </Text>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default IncomingMessage;
